import './App.css';

import CozyModsWiki from './CozyModsWiki';

function App() {
  return <CozyModsWiki />;
}

export default App;
